import {InjectionToken} from '@angular/core';

export interface MxEnvironmentService {
  getEnvironmentVariable(variable: string): string | boolean | number;
}

export const MX_ENVIRONMENT_TOKEN = new InjectionToken<MxEnvironmentService>('MX_ENVIRONMENT_TOKEN');
